/**
 * Manages the Socket.io connection lifecycle.
 * Call this ONCE in App.tsx alongside usePermissionSync().
 */
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth.store';
import { connectSocket, disconnectSocket } from '@/lib/socket';

export function useSocket(): void {
  const accessToken = useAuthStore((s) => s.accessToken);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated || !accessToken) {
      disconnectSocket();
      return;
    }
    connectSocket(accessToken);

    return () => {
      // Component unmount (App unmount = page close) — keep socket alive on re-renders
      // Don't disconnect here; the auth store logout() handles cleanup
    };
  }, [isAuthenticated, accessToken]);
}
